import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import uweb from 'vue-uweb'

Vue.use(uweb, '1272883543')
// import $ from 'jquery'
//import _ from 'lodash'

//import 'STATIC/sdk/js/sdk.js?t=1'
//import Share from 'STATIC/sdk/js/share.js?t=1'
import 'VENDOR/jsBridge/sdk.js?t=1'
import Share from 'VENDOR/jsBridge/share.js?t=1'

window.setShareInfo = Share;

import routes from 'ROUTE/app-router'
import Axios from 'axios';
import Client from 'UTIL/Client' //确认客户端来自哪里
import VueCookie from 'vue-cookie'
import qs from 'qs';

var FastClick = require('fastclick');
FastClick.attach(document.body);

import 'mint-ui/lib/style.css'
import {
  Toast
} from 'mint-ui';

Axios.defaults.baseURL = '/api'; //axios基础的前缀
// Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$http = Axios //全局使用Axios

Vue.use(VueRouter)
Vue.use(VueCookie)

Vue.prototype.$client = new Client();
// Vue.prototype.JsBridge = new JSBridge();
//Vue.$http = Axios;

const router = new VueRouter({ //路由配置
  // mode: (process.env.NODE_ENV == 'local') ? "hash" : "history", // ? 为何local环境使用hash模式呢 ???
  mode: "history",
  // mode:  "hash",
  base: '/',
  linkActiveClass: 'active',
  routes: routes
})

// VueCookie.delete('FOUNQ_TOKEN');   //!!!!!!!清除token信息！！！！
// VueCookie.set('FOUNQ_TOKEN', '422d6ff007d12fbc68fb16c4b1c0bd9d');  //切换登录
// VueCookie.set('FOUNQ_TOKEN', 'f33234ed4275953ed4ef3ccb5044b3d2');


Axios.interceptors.request.use((request) => {         //  引进qs Axios中使用post方法发送的不同的数据结构
  if (request.data && request.method === 'post') {
    request.data = qs.stringify(request.data.params);
  }
  return request;
});

Axios.interceptors.response.use( // 就得用上 axios 的拦截器。通过配置 http response inteceptor ，
  response => {
    //console.log(response);
    if (response.data.status == 'success') {
      console.log('axios success');
      return response.data.data;
    } else {
      //不需要先提示,允许通过错误码
      // if ([10018].includes(response.data.data.error_code)) {
      //     return response.data.data.error_code
      // }
      //全局失败Toast拦截
      console.log('axios fail');
      console.log(response.data);
      Toast({
        message: response.data.data.error,
        position: 'bottom', //弹出层错误提醒
        duration: 2000
      });
      //需要先提示,再允许通过错误码
      if ([10118].includes(response.data.data.error_code)) {
        return response.data.data.error_code
      }
      return false;
    }
  },
  error => {
    console.log('axios error');
    Toast({
      message: '请求异常,请检查网络',
      position: 'bottom',
      duration: 2000
    });
    return Promise.reject(error);
  });


router.beforeEach((to, from, next) => { //利用 vue-router 提供的钩子函数 beforeEach() 对路由进行判断。
  let token = VueCookie.get('FOUNQ_TOKEN');
  if (token) {
    Axios.get('user/info', { //等价于   Axios.get("'user/info?'token")
      params: {
        token: token
      }
    }).then((response) => { //正确返回后 设置sessionStorage.setItem
      if (response) {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('userinfo', JSON.stringify(response)); //对象形式json解析为字符串
      }
      document.title = to.meta.title //to.meta？？？
      next()
    }).catch((error) => {
      document.title = to.meta.title //to.meta？？？
      next()
    });
  } else {
    sessionStorage.clear();
    document.title = to.meta.title
    next()
  }
})

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js